import type { FaireProductEntity } from "../../entity_types/product";

export const p_wkngf25fzk: FaireProductEntity = {
  token: "p_wkngf25fzk",
  type: "product",
  name: "whale sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/903d9018acd9b53b5d61ee6aa06db28e150029ef4b53f9b328ebc0d2ca5c2628.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8c29cc6c94253f67034ffa7758640398950b5802df498fa21c0c182d7f73d21.jpeg",
  ],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n• vinyl sticker\n• 3" x 2"\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:09.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
